module.exports = __webpack_public_path__ + "static/media/KEFlogo.42eabd05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/logos/KEFlogo.jpg
// module id = 995
// module chunks = 0